<script lang="ts" setup>
import { PaperClipIcon } from '@heroicons/vue/24/outline';
</script>

<template>
  <li class="pl-3 pr-4 py-3 flex flex-wrap gap-2 items-center justify-between text-sm">
    <div class="flex text-sm text-slate-500">
      <PaperClipIcon class="h-5 w-5 mr-2 text-slate-400 hidden sm:block" />

      <slot />
    </div>

    <div class="flex items-center space-x-2">
      <slot name="actions" />
    </div>
  </li>
</template>
